import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';
import { OPTIONS_CONST } from '@/src/constants/options';
import { EntryType } from '@/src/models/EntryDto';

export const entryFilters: () => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = () => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },

  {
    key: 'titleLike',
    label: '제목',
    placeholder: '제목을 입력해주세요',
  },
  {
    key: 'createdAt',
    label: '등록 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'startedAt',
    label: '응모 시작 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['startedAtFrom', 'startedAtTo'],
  },
  {
    key: 'priorityDisplayYn',
    label: '우선 노출 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: OPTIONS_CONST.applied, value: 'true' },
      { label: OPTIONS_CONST.notApplied, value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'adminNameLike',
    label: '등록 관리자',
    placeholder: '관리자명을 입력해주세요',
  },
  {
    key: 'isExposed',
    label: '노출 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: OPTIONS_CONST.viewable, value: 'true' },
      { label: OPTIONS_CONST.notViewable, value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'type',
    label: '응모 유형',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      {
        value: EntryType.DAILY,
        label: '매일 참여',
      },
      {
        value: EntryType.NORMAL,
        label: '이벤트',
      },
      {
        value: EntryType.FIRST_SERVED,
        label: '선착순',
      },
      {
        value: EntryType.FREE,
        label: '무료',
      },
    ],
    type: ListFilterTypeObject.SELECT,
  },
];
